import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '擦亮城乡环境 建设美丽重庆';
const baseUrl = 'HJWSSSPINDEX20240314';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/news`,
  meta: {
    title: PAGE_TITLE,
    showfooter: true,
  },
  children: [
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
  ],
};
export default route;
